import { Tooltip as TooltipComponent, PlacesType } from 'react-tooltip';
import { useId } from 'react';

interface TooltipProps {
  overlay: (() => React.ReactNode) | React.ReactNode;
  targetClassName?: string;
  placement?: PlacesType;
  className?: string;
  visible?: boolean;
  children: any;
};

export function Tooltip(props: TooltipProps) {
  const id = useId();

  return (
    <>
      <span
        data-tooltip-place={props?.placement ?? 'right'}
        className={props.targetClassName}
        data-tooltip-id={id}
      >
        {props.children}
      </span>

      <TooltipComponent
        globalCloseEvents={{ scroll: true, clickOutsideAnchor: true }}
        className={props.className}
        isOpen={props.visible}
        openOnClick
        id={id}
      >
        {props.overlay}
      </TooltipComponent>
    </>
  );
}